<template>
    <div class="cart">
        <div class="row header">
            <div class="col-md-8">
                <h2 class="title">Carrinho</h2>
            </div>
            <div class="col-md-4 text-right">
                <Button :onClick="() => addCartItem()">Adicionar Item</Button >
            </div>
        </div>

        <div class="row items">
            <div class="col-12">
                <div v-if="value.items && value.items.length" class="itemList">
                    <CartItem 
                        v-for="(item, index) in value.items"
                        :key="`cart-item-${index}`"
                        :item="item"
                        :onRemove="() => removeCartItem(index)"
                    />
                </div>

                <p v-else class="helperText" v-bind:class="{ 'invalid-feedback': error }">
                    Nenhum item no carrinho
                </p>

                <p v-if="helperText" class="helperText" v-bind:class="{ 'invalid-feedback': error }">
                    {{ helperText }}
                </p>
            </div>
        </div>
        
        <div v-if="value.aditionals && value.aditionals.length" class="row aditionals">
            <div class="col-12">
                <h4 class="label">
                    Adicionais
                </h4>
            </div>

            <div class="col-12">
                <div class="aditionalList">
                    <AditionalItem v-for="(aditional, index) in value.aditionals" :key="`cart-aditional-${index}`" :aditional="aditional" />
                </div>
            </div>
        </div>

        <div class="summary">
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-sm-12 col-md-10 col-lg-9 col-xl-8">
                            <Select 
                                v-model="value.coupon"
                                :options="coupons"
                                label="Cupom de desconto"
                                :error="false"
                                :required="false"
                                :disableEmptyOption="false"
                                :getOptionLabel="option => `${option.code} (${getCouponValue(option, true)})`"
                                @change="() => $emit('change')"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <Summary 
                        :items="value.items || []"
                        :coupon="value.coupon || null"
                        :onRemoveCoupon="() => removeCoupon()"
                        :appId="appId"
                        :appCode="appCode"
                    />
                </div>
            </div>
        </div>

        <Modal
            v-model="productFormOpen"
            :onClose="() => {productFormOpen = false}"
            title="Adicionar Item"
            :showPrimaryButton="false"
            :showSecondaryButton="false"
        >
            <CartItemForm
                :appCode="appCode"
                :appId="appId"
                :enableExtendedCalendar="enableExtendedCalendar"
                :onCancel="() => {productFormOpen = false}"
                :onSave="createCartItem"
                :dashboardUrl="dashboardUrl"
                :useDashboardSeatMap="useDashboardSeatMap"
            />
        </Modal>
    </div>

</template>

<script>

import Button from '../../../Button';
import Select from '../../../Select';
import Modal from '../../../Modal';
import CartItemForm from './CartItemForm';
import CartItem from './CartItem';
import AditionalItem from './AditionalItem';
import Summary from './Summary';
import SellerApi from '../../../../services/SellerApi';

export default {
    components: { 
        Button, Select, Modal, CartItem, AditionalItem, CartItemForm, Summary
    },
    props: {
        appCode: String,
        appId: String,
        enableExtendedCalendar: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            type: Object,
            required: true,
        },
        helperText: {
            type: String,
            required: false
        },
        error: {
            type: Boolean,
            required: false,
            default: false
        },
        dashboardUrl: {
            type: String,
            required: true,
        },
        useDashboardSeatMap: {
            type: Boolean,
            required: true,
        },
    },
    data(){
        return {
            coupons: [],
            productFormOpen: false,
        };
    },
    computed: {
        cartHasResaleItems() {
            return !!this.value.items?.some(item => `${item.product.id_app}` !== this.appId);
        }
    },
    methods: {
        removeCartItem(index) {
            this.value.items.splice(index, 1);
            this.$emit('change')
        },
        removeCoupon() {
            this.value.coupon = null;
            this.$emit('change')
        },
        getCouponValue(coupon, formatted=false) {
            let value = coupon.discount_amount_cents / 100

            if (coupon.type === 'percentage') {
                value = coupon.discount_percentage

                if (formatted) {
                    return `${value}%`
                }

                return value
            }

            if (formatted) {
                return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            }
            
            return value
        },
        createCartItem(product) {
            const newValue = {
                ...this.value,
                items: [
                    ...this.value.items ?? [],
                    product,
                ]
            }
            this.$emit('input', newValue)

            this.productFormOpen = false;
        },
        addCartItem() {
            this.productFormOpen = true;
            this.$emit('change')
        },
        getCoupons() {
            this.couponsLoading = true

            SellerApi.Coupon.list(this.appCode).then((response) => {
                this.couponsLoading = false

                this.coupons = response
            }).catch((error) => {
                this.couponsLoading = false

                console.error(error)
            })
        },
    },
    mounted() {
        this.getCoupons()
    },
}
</script>

<style scoped lang="scss">
.cart {
    padding: 1rem;
    border: 1px solid #ccc;
    background-color: #f5f5f5;
    border-radius: 5px;
    margin-bottom: 20px;

    .header {
        margin-bottom: 20px;

        .title {
    
        }
    }

    .helperText {
        text-align: center;
        color: #666;
        padding: 1rem;

        &.invalid-feedback {
            color: #dc3545;
        }
    }

    .itemList {
        margin-bottom: 20px;
    }

    .aditionals {

        .aditionalList {
                
                .label {
        
                }
        }
    }

    .summary {
        padding-top: 20px;

        .divider {
            border-top: 1px solid #ccc;
        }
    }
}
</style>
